export default __webpack_public_path__ + "static/media/emptystate.4aa862a4.svg";